import { useContext } from 'react';
import { ContentContext } from '../../contexts/ContentContext';
import useContent from '../../hooks/useContent';
import useUnsavedChanges from '../../hooks/useUnsavedChanges';
import AdminTopbar from '../AdminTopbar';
import SaveBar from '../components/SaveBar';

export default function ContactEditor() {
  const { content, updateSection } = useContext(ContentContext);
  const { draft, isDirty, saving, lastSaved, update, save, discard } =
    useContent(content.contact);
  useUnsavedChanges(isDirty);

  const handleSave    = () => save(patch => updateSection('contact', patch));
  const handleDiscard = () => discard(content.contact);

  return (
    <div className="adm-page">
      <AdminTopbar title="Contact" />
      <SaveBar isDirty={isDirty} saving={saving} lastSaved={lastSaved}
               onSave={handleSave} onDiscard={handleDiscard} />

      <div className="adm-editor">
        <section className="adm-section">
          <h3 className="adm-section__title">Section Heading</h3>
          <div className="adm-field">
            <label className="adm-label">Heading</label>
            <input className="adm-input" value={draft.heading || ''}
              onChange={e => update({ heading: e.target.value })} />
          </div>
          <div className="adm-field">
            <label className="adm-label">Subtext</label>
            <textarea className="adm-textarea" rows={2} value={draft.subtext || ''}
              onChange={e => update({ subtext: e.target.value })} />
          </div>
        </section>

        <section className="adm-section">
          <h3 className="adm-section__title">Contact Details</h3>

          <div className="adm-field">
            <label className="adm-label">Email</label>
            <input className="adm-input" type="email" value={draft.email || ''}
              onChange={e => update({ email: e.target.value })} />
          </div>

          <div className="adm-field">
            <label className="adm-label">Phone</label>
            <input className="adm-input" value={draft.phone || ''}
              onChange={e => update({ phone: e.target.value })} />
          </div>

          <div className="adm-field">
            <label className="adm-label">Website</label>
            <input className="adm-input" value={draft.website || ''}
              onChange={e => update({ website: e.target.value })} />
          </div>

          <div className="adm-field">
            <label className="adm-label">Location / City</label>
            <input className="adm-input" value={draft.location || ''}
              onChange={e => update({ location: e.target.value })} />
          </div>
        </section>

        <section className="adm-section">
          <h3 className="adm-section__title">Social Links</h3>

          <div className="adm-field">
            <label className="adm-label">Instagram URL</label>
            <input className="adm-input" placeholder="https://instagram.com/…"
              value={draft.instagram || ''}
              onChange={e => update({ instagram: e.target.value })} />
          </div>

          <div className="adm-field">
            <label className="adm-label">LinkedIn URL</label>
            <input className="adm-input" placeholder="https://linkedin.com/…"
              value={draft.linkedin || ''}
              onChange={e => update({ linkedin: e.target.value })} />
          </div>

          <div className="adm-field">
            <label className="adm-label">Facebook URL</label>
            <input className="adm-input" placeholder="https://facebook.com/…"
              value={draft.facebook || ''}
              onChange={e => update({ facebook: e.target.value })} />
          </div>
        </section>

        <section className="adm-section">
          <h3 className="adm-section__title">CTA Banner</h3>

          <div className="adm-field">
            <label className="adm-label">CTA Headline</label>
            <input className="adm-input" value={draft.ctaHeadline || ''}
              onChange={e => update({ ctaHeadline: e.target.value })} />
          </div>

          <div className="adm-field">
            <label className="adm-label">CTA Button Label</label>
            <input className="adm-input" value={draft.ctaLabel || ''}
              onChange={e => update({ ctaLabel: e.target.value })} />
          </div>
        </section>
      </div>
    </div>
  );
}
